import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from './quote';
import {
  CreateQuoteStep1Container,
  CreateQuoteStep2Container,
  CreateQuoteStep3Container,
  ReviewQuoteContainer,
  steps,
} from '.';
import QuoteWizardContext from './QuoteWizardContext';
import { QuoteProductConfiguration } from './quoteProductConfiguration';
import { ProductConfiguration } from '../products/productConfiguration';
import { monitorChangesOn } from '@ami/react/core';
import { quoteWizardMode } from './quoteWizardMode';
import { QuoteOptInDiscountOutput } from './entities/QuoteOptInDiscountOutput';

class QuoteWizardComponent extends React.PureComponent {
  static propTypes = {
    contact: PropTypes.instanceOf(Object),
    quote: PropTypes.instanceOf(Quote),
    context: PropTypes.any.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration),
    completeStep1: PropTypes.func.isRequired,
    completeStep2: PropTypes.func.isRequired,
    completeStep3: PropTypes.func.isRequired,
    cancelStep2: PropTypes.func.isRequired,
    step: PropTypes.string.isRequired,
    setStep: PropTypes.func.isRequired,
    addProduct: PropTypes.func.isRequired,
    updateProduct: PropTypes.func.isRequired,
    navigateToQuotesDetails: PropTypes.func.isRequired,
    navigateToDashboard: PropTypes.func.isRequired,
    finishQuoteReview: PropTypes.func.isRequired,
    updateQuote: PropTypes.func.isRequired,
    removeProduct: PropTypes.func.isRequired,
    setContact: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(
      Object.keys(quoteWizardMode).map((item) => quoteWizardMode[item])
    ).isRequired,
    submitting: PropTypes.bool.isRequired,
    markStep3SelectionInProgress: PropTypes.func.isRequired,
    preparingForReview: PropTypes.bool.isRequired,
    sharedDocuments: PropTypes.array.isRequired,
    onDownload: PropTypes.func.isRequired,
    documentIdDownloading: PropTypes.string,
    onloadSharedDocuments: PropTypes.func.isRequired,
    optInDiscounts: PropTypes.arrayOf(PropTypes.instanceOf(QuoteOptInDiscountOutput)).isRequired,
    showPricingSpinner: PropTypes.bool.isRequired,
    showReviewAlert: PropTypes.bool.isRequired
  };

  isQuoteWizarEditMode() {
    return this.props.mode === quoteWizardMode.editMode;
  }

  render() {
    const {
      contact,
      quote,
      context,
      productConfiguration,
      quoteProductConfiguration,
      completeStep1,
      completeStep2,
      completeStep3,
      cancelStep2,
      step,
      setStep,
      addProduct,
      updateProduct,
      navigateToQuotesDetails,
      navigateToDashboard,
      finishQuoteReview,
      updateQuote,
      removeProduct,
      setContact,
      mode,
      submitting,
      markStep3SelectionInProgress,
      preparingForReview,
      sharedDocuments,
      onDownload,
      documentIdDownloading,
      onloadSharedDocuments,
      optInDiscounts,
      showPricingSpinner,
      showReviewAlert
    } = this.props;
    const isEditMode = this.isQuoteWizarEditMode();
    return (
      <QuoteWizardContext.Provider value={context}>
        <CreateQuoteStep1Container
          productConfiguration={productConfiguration}
          onContinue={completeStep1}
          show={step === steps.step1}
          submitting={submitting}
          setContact={setContact}
          mode={mode}
        />
        <CreateQuoteStep2Container
          show={quote !== null && step === steps.step2}
          step1={quote && quote.step1}
          productConfiguration={productConfiguration}
          quoteProductConfiguration={quoteProductConfiguration}
          onQuoteUpdated={updateQuote}
          onContinue={completeStep2}
          onCancel={cancelStep2}
          quote={quote}
          onloadSharedDocuments={onloadSharedDocuments}
        />
        <CreateQuoteStep3Container
          show={quote !== null && step === steps.step3}
          step1={quote && quote.step1}
          contact={contact}
          productConfiguration={productConfiguration}
          quoteProductConfiguration={quoteProductConfiguration}
          onAddProduct={addProduct}
          onUpdateProduct={updateProduct}
          onContinue={completeStep3}
          submitting={submitting}
          markSelectionInProgress={markStep3SelectionInProgress}
          quote={quote}
          preparingForReview={preparingForReview}
          mode={mode}
          onloadSharedDocuments={onloadSharedDocuments}
          onQuoteUpdated={updateQuote}
        />
        <ReviewQuoteContainer
          isEditMode={isEditMode}
          show={quote !== null && step === steps.review}
          quote={quote}
          productConfiguration={productConfiguration}
          quoteProductConfiguration={quoteProductConfiguration}
          onQuoteAccepted={finishQuoteReview}
          onQuoteUpdated={updateQuote}
          onAddCoupler={(quoteAttachmentPoint) =>
            setStep(steps.step3, {
              attachmentPointId: quoteAttachmentPoint.id,
              addCoupler: true,
            })
          }
          onAddProduct={() => setStep(steps.step3)}
          onEditProduct={(quoteProductId) =>
            setStep(steps.step3, { quoteProductId })
          }
          onRemoveProduct={removeProduct}
          onCancelEdit={() =>
            isEditMode
              ? navigateToQuotesDetails(quote.id)
              : navigateToDashboard()
          }
          submitting={submitting}
          sharedDocuments={sharedDocuments}
          onDownload={onDownload}
          documentIdDownloading={documentIdDownloading}
          onloadSharedDocuments={onloadSharedDocuments}
          optInDiscounts={optInDiscounts}
          showPricingSpinner={showPricingSpinner}
          showReviewAlert={showReviewAlert}
        />
      </QuoteWizardContext.Provider>
    );
  }
}

export default monitorChangesOn(QuoteWizardComponent);
